import { Pipe, PipeTransform } from 'angular-ts-decorators';

import { isNumber, round } from 'lodash';

export type PercentageFilter = (input: number) => number;

interface IPercentage {
  transform: PercentageFilter;
}

/**
 * Format the value as percentage
 * @param fraction the value that is provide
 * @return value formated as percentage
 */
@Pipe({ name: 'percentage' })
export class PercentagePipe implements PipeTransform, IPercentage {
  constructor() {
    'ngInject';
  }

  public transform(fraction: number): number {
    if (isNumber(fraction)) {
      return round(fraction * 100);
    }

    return fraction;
  }
}
